import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-gift-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-semibold text-background-50 whitespace-nowrap">
                福利导航
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              一站式福利资源聚合平台，为您精准汇聚购物优惠、会员权益、生活补贴、职场福利等多维度福利信息。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-background-50 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/gouwu-youhui"
                  className="text-sm text-background-400 hover:text-background-50 transition-colors"
                >
                  分类浏览
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-50 transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@fulidaohang.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-8888</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 福利导航 fulidaohang.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-sm text-background-500 hover:text-background-200 transition-colors"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-sm text-background-500 hover:text-background-200 transition-colors"
              rel="nofollow"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}